import config from 'config';

export const isTermsAndPrivacyCheckboxSupported = (tld) => {
  return config
    .get('public.brand.termsAndPrivacyDomainConfigurations.checkbox')
    ?.includes(tld);
};

export const isTermsAndPrivacyCopySupported = (tld) => {
  return config
    .get('public.brand.termsAndPrivacyDomainConfigurations.copy')
    ?.includes(tld);
};
